/* tslint:disable */
/* eslint-disable */
/**
 * Private UI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: ${project.version}
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ReportForDeviceCounterResponse,
    ReportForDeviceCounterResponseFromJSON,
    ReportForDeviceCounterResponseFromJSONTyped,
    ReportForDeviceCounterResponseToJSON,
} from './ReportForDeviceCounterResponse';

/**
 * 
 * @export
 * @interface ReportForDeviceCountersResponse
 */
export interface ReportForDeviceCountersResponse {
    /**
     * 
     * @type {Array<ReportForDeviceCounterResponse>}
     * @memberof ReportForDeviceCountersResponse
     */
    elements: Array<ReportForDeviceCounterResponse> | null;
}

export function ReportForDeviceCountersResponseFromJSON(json: any): ReportForDeviceCountersResponse {
    return ReportForDeviceCountersResponseFromJSONTyped(json, false);
}

export function ReportForDeviceCountersResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReportForDeviceCountersResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'elements': (json['elements'] === null ? null : (json['elements'] as Array<any>).map(ReportForDeviceCounterResponseFromJSON)),
    };
}

export function ReportForDeviceCountersResponseToJSON(value?: ReportForDeviceCountersResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'elements': (value.elements === null ? null : (value.elements as Array<any>).map(ReportForDeviceCounterResponseToJSON)),
    };
}

